import React, { useState, useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../../hooks/useAuth';
import ContactsMailbox from '../profile/ContactsMailbox';
import Layout from '../layout/Layout';

const ContactsMailboxRoute = () => {
    const { isLoggedIn } = useAuth();
    const [searchParams] = useSearchParams();
    const rid = searchParams.get('rid');
    const [mailboxStatus, setMailboxStatus] = useState(null);

    useEffect(() => {
        if (isLoggedIn || rid) return;
        let cancelled = false;
        fetch('/api/contacts-mailbox/status/', { credentials: 'include' })
            .then((res) => res.json())
            .then((data) => {
                if (!cancelled) setMailboxStatus({ hasAccess: data.has_mailbox_access === true });
            })
            .catch(() => {
                if (!cancelled) setMailboxStatus({ hasAccess: false });
            });
        return () => { cancelled = true; };
    }, [isLoggedIn, rid]);

    if (isLoggedIn) {
        return <Navigate to="/profile/mailbox" replace />;
    }

    if (rid) {
        return <Layout><ContactsMailbox /></Layout>;
    }

    if (mailboxStatus === null) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!mailboxStatus.hasAccess) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Layout>
            <ContactsMailbox />
        </Layout>
    );
};

export default ContactsMailboxRoute;
